import { render, staticRenderFns } from "./PokemonTypes.vue?vue&type=template&id=abaec8e0&"
import script from "./PokemonTypes.vue?vue&type=script&lang=js&"
export * from "./PokemonTypes.vue?vue&type=script&lang=js&"
import style0 from "./PokemonTypes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports